import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Render immediately without async wrapper to prevent silent failures
const root = document.getElementById("root");

if (root) {
  try {
    createRoot(root).render(<App />);
  } catch (err) {
    console.error("Failed to render app:", err);
    root.innerHTML = `<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:sans-serif;color:#c00"><h1>应用加载失败，请刷新页面</h1></div>`;
  }
}

// Global safety net for unhandled promise rejections
window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled rejection:", event.reason);
  event.preventDefault();
});
